module.exports = __webpack_public_path__ + "static/media/faq4.be147113.jpeg";